import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const SpotlightContext = createContext(null);

type Props = {
  children: ReactElement;
};

const SpotlightProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["ads"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`radar/ads`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <SpotlightContext.Provider value={contextValue}>
      {children}
    </SpotlightContext.Provider>
  );
};

export default SpotlightProvider;
